import React from 'react';

import { withTranslation, i18n as I18n } from '../utils/i18n';
import { formatTextAsParagraphs } from '../utils/display';

import Page from '../components/page';

const Disclaimer = () => {
  return (
    <Page title={I18n.t('disclaimer.page_title')}>
      <main>
        <section>
          <div className="section-content section-content--static">
            <h1>{I18n.t('disclaimer.title')}</h1>

            {formatTextAsParagraphs(I18n.t('disclaimer.content'))}
          </div>
        </section>
      </main>
    </Page>
  );
};

export default withTranslation('common')(Disclaimer);
